'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Define = undefined;

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _theme = require('../common/theme');

var _load = require('../common/load');

var _load2 = _interopRequireDefault(_load);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Define = exports.Define = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(Define, _Component);

    function Define(props) {
        (0, _classCallCheck3.default)(this, Define);

        // props.data = !!_ && _.cloneDeep(props.data);
        var _this = (0, _possibleConstructorReturn3.default)(this, (Define.__proto__ || (0, _getPrototypeOf2.default)(Define)).call(this, props));

        _this.state = {
            loading: true,
            echarts: null,
            options: !!_lodash2.default && _lodash2.default.cloneDeep(props.options),
            Theme: _theme.Theme
        };
        _this.initChart = _this.initChart.bind(_this);
        _this.reRender = _this.reRender.bind(_this);
        _this.handleResize = _this.handleResize.bind(_this);
        _this.LOAD_CHART = _load2.default.loadJS('echarts', 'https://g.alicdn.com/wallegroup/third-lib/echarts/3.8.5/echarts.min.js');
        return _this;
    }

    (0, _createClass3.default)(Define, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            if (typeof echarts !== 'undefined') {
                this.setState({
                    loading: false,
                    echarts: echarts
                }, function () {
                    _this2.initChart();
                });
            } else {
                if (this.LOAD_CHART) {
                    this.LOAD_CHART.addEventListener('load', function () {
                        _this2.setState({
                            loading: false,
                            echarts: echarts
                        }, function () {
                            _this2.initChart();
                        });
                    });

                    // IE 监听资源是否加载完成
                    if (this.LOAD_CHART && this.LOAD_CHART.onreadystatechange) {
                        this.LOAD_CHART.onreadystatechange = function () {
                            var state = _this2.LOAD_CHART.readyState;
                            if (state === 'loaded' || state === 'complete') {
                                _this2.setState({
                                    loading: false,
                                    echarts: echarts
                                }, function () {
                                    _this2.initChart();
                                });
                            }
                        };
                    }
                }
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this3 = this;

            if (this.json2stringify(this.filterProps(this.props)) !== this.json2stringify(this.filterProps(nextProps)) || this.json2stringify(this.filterProps(nextProps.options)) !== this.json2stringify(this.filterProps(this.state.options))) {
                this.setState({
                    loading: false,
                    options: !!_lodash2.default && _lodash2.default.cloneDeep(nextProps.options)
                }, function () {
                    _this3.initChart();
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.chartInstance && this.chartInstance.dispose();
            window.removeEventListener('resize', this.handleResize);
        }

        /**
         * 过滤多余属性
         */

    }, {
        key: 'filterProps',
        value: function filterProps(props) {
            var attr = (0, _assign2.default)({}, props);
            for (var key in attr) {
                if (typeof Define.propTypes[key] === 'undefined') {
                    attr[key] = null;
                }
            }
            return attr;
        }

        /**
         * undefined 过滤
         */

    }, {
        key: 'filterMap',
        value: function filterMap(filterArray, props) {
            var options = {};
            filterArray.map(function (key) {
                var option = props[key];
                if (option !== undefined) {
                    options[key] = option;
                }
            });
            return options;
        }

        /**
         * JSON.stringify 避免循环引用错误
         */

    }, {
        key: 'json2stringify',
        value: function json2stringify(attr) {
            var stringify = "";
            if (attr) {
                var cache = [];
                stringify = (0, _stringify2.default)(attr, function (key, value) {
                    if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'object' && value !== null) {
                        if (cache.indexOf(value) !== -1) {
                            return;
                        }
                        cache.push(value);
                    }
                    return value;
                });
                cache = null;
            }
            return stringify;
        }

        /**
         * 监听 resize 事件
         */

    }, {
        key: 'handleResize',
        value: function handleResize() {
            this.chartInstance && this.chartInstance.resize();
        }

        /**
         * 初始化图表
         */

    }, {
        key: 'initChart',
        value: function initChart() {
            var _props = this.props,
                onReady = _props.onReady,
                repaint = _props.repaint;
            var _state = this.state,
                echarts = _state.echarts,
                Theme = _state.Theme;

            var node = this.refs.chart;
            if (!echarts || !node) {
                return;
            }
            var options = void 0;
            if (this.props.options) {
                options = this.props.options;
            } else {
                options = this.filterMap(['title', 'legend', 'grid', 'xAxis', 'yAxis', 'polar', 'radiusAxis', 'angleAxis', 'radar', 'dataZoom', 'dataRange', 'calculable', 'visualMap', 'tooltip', 'axisPointer', 'toolbox', 'brush', 'geo', 'parallel', 'parallelAxis', 'singleAxis', 'timeline', 'graphic', 'calendar', 'series', 'color', 'backgroundColor', 'textStyle', 'animation', 'renderAsImage', 'roamController'], this.props);
            }
            echarts.registerTheme('Rookie', Theme);
            if (repaint) {
                this.repaintChart(node);
            } else {
                this.drawChart(node);
            }
            this.chartInstance.setOption(options);
            window.addEventListener('resize', this.handleResize);
            // 透传实例
            if (onReady) {
                onReady(this.chartInstance);
            }
        }

        /**
         * 绘制图形
         */

    }, {
        key: 'drawChart',
        value: function drawChart(node) {
            var echarts = this.state.echarts;

            if (!echarts.getInstanceByDom(node)) {
                this.chartInstance = echarts.init(node, 'Rookie');
            }
        }

        /**
         * 强制重新渲染
         */

    }, {
        key: 'repaintChart',
        value: function repaintChart(node) {
            if (this.chartInstance) {
                this.chartInstance.dispose(); // 销毁重新渲染
            }
            this.chartInstance = echarts.init(node, 'Rookie');
        }

        /**
         * 借助 ref 透传组件实例进行指定图形重新渲染
         */

    }, {
        key: 'reRender',
        value: function reRender() {
            var _props2 = this.props,
                onReady = _props2.onReady,
                repaint = _props2.repaint;
            var _state2 = this.state,
                echarts = _state2.echarts,
                Theme = _state2.Theme;

            var node = this.refs.chart;
            if (!echarts || !node) {
                return;
            }
            var options = void 0;
            if (this.props.options) {
                options = this.props.options;
            } else {
                options = this.filterMap(['title', 'legend', 'grid', 'xAxis', 'yAxis', 'polar', 'radiusAxis', 'angleAxis', 'radar', 'dataZoom', 'dataRange', 'calculable', 'visualMap', 'tooltip', 'axisPointer', 'toolbox', 'brush', 'geo', 'parallel', 'parallelAxis', 'singleAxis', 'timeline', 'graphic', 'calendar', 'series', 'color', 'backgroundColor', 'textStyle', 'animation', 'renderAsImage', 'roamController'], this.props);
            }
            echarts.registerTheme('Rookie', Theme);
            this.repaintChart(node);
            this.chartInstance.setOption(options);
            window.addEventListener('resize', this.handleResize);
            // 透传实例
            if (onReady) {
                onReady(this.chartInstance);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                _props3$className = _props3.className,
                className = _props3$className === undefined ? '' : _props3$className,
                _props3$style = _props3.style,
                style = _props3$style === undefined ? {} : _props3$style,
                width = _props3.width,
                height = _props3.height;

            var css = (0, _assign2.default)({}, style, {
                width: width,
                height: height
            });
            return _react2.default.createElement(
                'div',
                { className: 'cn-chart ' + className, style: css, ref: 'chart' },
                this.state.loading ? _react2.default.createElement(
                    'div',
                    { className: 'loading' },
                    'loading...'
                ) : null
            );
        }
    }]);
    return Define;
}(_react.Component), _class.propTypes = {
    className: _propTypes2.default.string,
    style: _propTypes2.default.object,
    repaint: _propTypes2.default.bool,
    height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    onReady: _propTypes2.default.func,
    title: _propTypes2.default.object,
    legend: _propTypes2.default.object,
    grid: _propTypes2.default.object,
    xAxis: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
    yAxis: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
    polar: _propTypes2.default.object,
    radiusAxis: _propTypes2.default.object,
    angleAxis: _propTypes2.default.object,
    radar: _propTypes2.default.object,
    dataZoom: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
    dataRange: _propTypes2.default.object,
    calculable: _propTypes2.default.bool,
    visualMap: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
    tooltip: _propTypes2.default.object,
    axisPointer: _propTypes2.default.object,
    toolbox: _propTypes2.default.object,
    brush: _propTypes2.default.object,
    geo: _propTypes2.default.object,
    parallel: _propTypes2.default.object,
    parallelAxis: _propTypes2.default.object,
    singleAxis: _propTypes2.default.object,
    timeline: _propTypes2.default.object,
    graphic: _propTypes2.default.object,
    calendar: _propTypes2.default.object,
    series: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
    color: _propTypes2.default.array,
    backgroundColor: _propTypes2.default.string,
    textStyle: _propTypes2.default.object,
    animation: _propTypes2.default.bool,
    renderAsImage: _propTypes2.default.bool,
    roamController: _propTypes2.default.object
}, _class.defaultProps = {
    width: '100%',
    height: '500px',
    repaint: false
}, _temp);
exports.default = Define;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-chart@0.0.14@@alicd/crui-chart/lib/components/Define.js
// module id = 607
// module chunks = 0